var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDesign = function SvgDesign(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4347 28.1265H16.5847C17.7847 28.1265 18.5597 27.2765 18.3347 26.239L17.8222 23.9766H12.1972L11.6847 26.239C11.4597 27.214 12.3097 28.1265 13.4347 28.1265Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8257 23.9657L19.9882 22.0406C21.2007 20.9656 21.2507 20.2155 20.2882 19.003L16.4757 14.1656C15.6757 13.1531 14.3632 13.1531 13.5632 14.1656L9.75068 19.003C8.78818 20.2155 8.78818 21.0031 10.0507 22.0406L12.2132 23.9657",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0078 13.9043V17.0668",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9312 6.48829L12.9562 5.51326C12.3687 4.92576 12.3687 3.97582 12.9562 3.38832L13.9312 2.41328C14.5187 1.82578 15.4687 1.82578 16.0562 2.41328L17.0312 3.38832C17.6187 3.97582 17.6187 4.92576 17.0312 5.51326L16.0562 6.48829C15.4687 7.07579 14.5187 7.07579 13.9312 6.48829Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3125 12.2637H25.6875C26.5125 12.2637 27.1875 12.9387 27.1875 13.7637V15.1387C27.1875 15.9637 26.5125 16.6387 25.6875 16.6387H24.3125C23.4875 16.6387 22.8125 15.9637 22.8125 15.1387V13.7637C22.8125 12.9387 23.4875 12.2637 24.3125 12.2637Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6875 12.2637H4.3125C3.4875 12.2637 2.8125 12.9387 2.8125 13.7637V15.1387C2.8125 15.9637 3.4875 16.6387 4.3125 16.6387H5.6875C6.5125 16.6387 7.1875 15.9637 7.1875 15.1387V13.7637C7.1875 12.9387 6.5125 12.2637 5.6875 12.2637Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1797 12.625L16.5547 6",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82812 12.625L13.4531 6",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDesign, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Design.4592676a.svg";
export { ForwardRef as ReactComponent };